import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const AlertWrapperStyled = styled(Box)({
  padding: '0px 24px',
  boxSizing: 'border-box',
});
